import { render } from "./agentSerial.vue?vue&type=template&id=6e479120&scoped=true"
import script from "./agentSerial.vue?vue&type=script&lang=js"
export * from "./agentSerial.vue?vue&type=script&lang=js"

import "./agentSerial.vue?vue&type=style&index=0&id=6e479120&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6e479120"

export default script